export default __webpack_public_path__ + "static/media/delete-danger.e9b4d686.svg";